import React, { useState, useRef } from 'react';
import { Box, Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import LoadingButton from '@mui/lab/LoadingButton';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import ApiHelper from 'utils/apiHelper';
import { convertDate } from 'utils/commonHelpers';

const EditScriptDialog = ({ onClose, onCloseCancel, data }) => {
    const fileInput = useRef(null);
    const [scriptName, setScriptName] = useState(data.name);
    const [scriptDescription, setScriptDescription] = useState(data.description);
    const [updatedDate, setUpdatedDate] = useState(data.updated);
    const [fileName, setFileName] = useState(data.file);
    const [file, setFile] = useState();
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFile(e.target.files[0]);
        data.file = e.target.files[0].name;
        setFileName(e.target.files[0].name);
    };

    const handleSubmit = () => {
        if (!file && fileName == '') {
            toast.warning('Please select the script file');
            return true;
        }
        const formData = new FormData();
        if (file) {
            formData.append('file', file);
        }
        formData.append('file_name', fileName);
        formData.append('name', scriptName);
        formData.append('description', scriptDescription);
        formData.append('updated_date', convertDate(updatedDate));
        setLoading(true);
        ApiHelper.put(`/api/server/scripts/${data.id}/`, formData)
            .then(() => {
                toast.success('Successfully updated');
                onClose();
                setLoading(false);
            })
            .catch((err) => {
                toast.error(`Fail! ${err.response.data.message}`);
                setLoading(false);
            });
    };

    return (
        <Dialog open={true} onClose={onCloseCancel}>
            <DialogTitle sx={{ fontSize: '16px' }}>Edit Script</DialogTitle>
            <DialogContent sx={{ minWidth: '500px' }}>
                <Box sx={{ mb: 3, mt: 3 }}>
                    <TextField
                        sx={{
                            width: '100%'
                        }}
                        label="Script Name"
                        value={scriptName}
                        onChange={(e) => setScriptName(e.target.value)}
                    />
                </Box>
                <Box sx={{ mb: 3, mt: 3 }}>
                    <TextField
                        sx={{
                            width: '100%'
                        }}
                        label="Script Description"
                        value={scriptDescription}
                        onChange={(e) => setScriptDescription(e.target.value)}
                    />
                </Box>
                <Box sx={{ mb: 3, mt: 3 }}>
                    <TextField
                        sx={{
                            width: '100%'
                        }}
                        label="File Name"
                        value={file ? file.name : fileName}
                        disabled={true}
                    />
                </Box>
                <Box sx={{ mb: 3, mt: 3 }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="Updated Date"
                            value={updatedDate}
                            onChange={(newValue) => {
                                setUpdatedDate(newValue);
                            }}
                            renderInput={(params) => <TextField {...params} sx={{ width: '100%' }} />}
                        />
                    </LocalizationProvider>
                </Box>
                <Box sx={{ mt: 3, mb: 3, display: 'flex' }}>
                    <Button color="primary" variant="contained" onClick={() => fileInput.current.click()}>
                        Choose Script File
                    </Button>
                    <input type="file" accept=".ps1" ref={fileInput} style={{ display: 'none' }} onChange={handleChange} />
                    {file && <Typography sx={{ marginLeft: '15px', mt: 1 }}>{file ? file.name : fileName}</Typography>}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCloseCancel}>Cancel</Button>
                <LoadingButton loading={loading} onClick={handleSubmit} color="primary" variant="contained">
                    Submit
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
};

EditScriptDialog.propTypes = {
    onClose: PropTypes.func,
    onCloseCancel: PropTypes.func,
    data: PropTypes.object
};

export default EditScriptDialog;
